// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const navigation = {
  top_level_navigation: {
    contentful_name: 'Top Level Navigation (DEFAULT DO NOT CHANGE)',
    desktop_pages: {
      hsa: '健康储蓄账户',
      health: '健康',
      review: '审核',
      profile: '个人资料',
      taxSavings: '税收优惠',
      eligibility: '资格',
      supplemental: '补充',
    },
    mobile_pages: {
      hsa: '健康储蓄账户(HSA)',
      risk: '风险',
      review: '审核',
      results: '您的结果',
      planning: '家庭规划',
      'you&family': '您和家人',
      eligibility: '资格',
      houseIncome: '家庭收入',
      medications: '药物',
      utilization: '使用情况',
      supplemental: '补充',
      capacityToPay: '支付能力',
    },
    menu_icon: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/navigationbar/menu-icon.svg',
    close_button: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/navigationbar/close-btn.svg',
    security_header: {
      heading: '您的安全是我们的首要任务。',
      lockIcon: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/navigationbar/security-lock.svg',
      badgeIcon: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/navigationbar/security.svg',
    },
    security_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'ALEX 努力确保您的数据安全。我们保护您信息的隐私,未经您的许可,绝不会与任何第三方共享您的数据。如需了解更多信息,请查看我们的',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '隐私政策',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    premium_select: {
      weekly: '每周 (/周)',
      monthly: '每月 (/月)',
      biWeekly: '双周 (/双周)',
      startingAt: '起价',
      semiMonthly: '半月 (/半月)',
    },
    english_flag: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/navigationbar/usa-flag.svg',
    spanish_flag: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/navigationbar/spain-flag.png',
    premium_select_with_abbreviation: {
      weekly: {
        display: '每周',
        abbreviation: '(/周)',
      },
      monthly: {
        display: '每月',
        abbreviation: '(/月)',
      },
      biWeekly: {
        display: '双周',
        abbreviation: '(/双周)',
      },
      semiMonthly: {
        display: '半月',
        abbreviation: '(/半月)',
      },
    },
    mobile_nav_instructions: '点击任何已解锁的项目进行导航。随时更新您的个人资料以更新您的健康和补充结果。',
    mobile_nav_close_btn: '关闭',
    pay_period_label: '您多久领一次工资?',
    language_toggle_label: '选择您的首选语言',
    pay_period_options: {
      weekly: {
        display: '每周',
        abbreviation: '(/周)',
      },
      monthly: {
        display: '每月',
        abbreviation: '(/月)',
      },
      bi_weekly: {
        display: '双周',
        abbreviation: '(/双周)',
      },
      semi_monthly: {
        display: '半月',
        abbreviation: '(/半月)',
      },
    },
    alex_id_login_btn: '登录',
    alex_id_signup_btn: '注册',
    alex_id_logout_btn: '退出登录',
    alex_id_account_btn: '账户',
    alex_id_reset_password_btn: '重置密码',
    alex_id_update_btn: 'ALEX支持',
    alex_id_update_btn_url:
      'https://jellyvision.zendesk.com/hc/zh-cn/sections/25777134982551-关于ALEX的问题-我们有答案',
    alex_id_delete_btn: '删除我的账户',
    alex_id_google: '已使用 Google 登录',
    alex_id_help: '如需更改姓名或删除ID,请发送电子邮件至:',
    alex_id_reset_password_text: '我们刚刚向您发送了一封重置密码的邮件。',
    alex_id_reset_password_error: '抱歉,出现错误。请稍后再试。',
    review_mode_header: '您处于审阅模式',
  },
};
